"use client";
import React from "react";
import { useState, useEffect, useRef } from "react";
import "./compare.scss";

const Compare = ({
  before,
  after,
  className = "",
  ...props
}: {
  before: React.ReactNode;
  after: React.ReactNode;
  className?: string;
  [key: string]: any;
}) => {
  const [left, setLeft] = useState(50);
  const [isDragging, setIsDragging] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const onMouseMove = (e: MouseEvent) => {
      if (isDragging && ref.current) {
        const rect = ref.current.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const percent = (x / rect.width) * 100;
        if (percent < 0) setLeft(0);
        else if (percent > 100) setLeft(100);
        else setLeft(percent);
      }
      e.preventDefault();
    };

    const onMouseUp = () => {
      setIsDragging(false);
    };

    document.addEventListener("mousemove", onMouseMove);
    document.addEventListener("mouseup", onMouseUp);

    return () => {
      document.removeEventListener("mousemove", onMouseMove);
      document.removeEventListener("mouseup", onMouseUp);
    };
  }, [isDragging]);

  return (
    <div className={`compare ${className}`} ref={ref} {...props}>
      <div
        className="compare__separator"
        style={{ left: left + "%" }}
        onMouseDown={(e) => {
          setIsDragging(true);
        }}
        onTouchStart={(e) => {
          setIsDragging(true);
        }}
        onTouchMove={(e) => {
          if (isDragging && ref.current) {
            const rect = ref.current.getBoundingClientRect();
            const x = e.touches[0].clientX - rect.left;
            const percent = (x / rect.width) * 100;
            if (percent < 0) setLeft(0);
            else if (percent > 100) setLeft(100);
            else setLeft(percent);
          }
        }}
        onClick={(e) => {
          e.preventDefault();
        }}
      />
      <div className="compare__before">{before}</div>
      <div
        className="compare__after"
        style={{ clipPath: `inset(0 0 0 ${left}%)` }}
      >
        {after}
      </div>
    </div>
  );
};

export default Compare;
